import React, { ReactNode, useEffect, useState } from 'react';
import { Field } from 'react-final-form';

import { Grid } from '@xsolla/ui-core';

import { CardFrame, CardIconWrapper, CardLabel } from './style';

type CardOption = {
  label: string;
  name: string;
  icon?: ReactNode;
  disabled?: boolean;
  dataTestId?: string;
};

type ActiveCards = {
  [key: string]: boolean;
};

type Props = {
  name: string;
  options: CardOption[];
  defaultValue?: ActiveCards;
  rowLength?: number;
  onChange?: (values: ActiveCards) => void;
};

const CardGroup = ({
  name,
  options,
  defaultValue,
  rowLength = 3,
  onChange
}: Props): JSX.Element => {
  const [activeCards, setActiveCards] = useState<ActiveCards>(defaultValue || {});

  useEffect(() => {
    if (defaultValue) {
      setActiveCards(defaultValue);
    }
  }, [defaultValue]);

  const cardHandler = (
    optionName: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handler: (event: React.ChangeEvent<ActiveCards> | any) => void
  ) => {
    const selectedCards = {
      ...activeCards,
      [optionName]: !activeCards[optionName]
    };
    setActiveCards(selectedCards);
    handler(selectedCards);
    if (onChange) {
      onChange(activeCards);
    }
  };

  return (
    <Field name={name}>
      {({ input }) => {
        return (
          <Grid
            gap={16}
            cols={options.length >= rowLength ? rowLength : options.length}
            allowOverflow>
            {options.map(({ name: cardName, icon, label, dataTestId, disabled = false }) => {
              return (
                <CardFrame
                  data-test-id={dataTestId}
                  active={activeCards[cardName]}
                  onClick={() => {
                    if (!disabled) {
                      cardHandler(cardName, input.onChange);
                    }
                  }}
                  key={cardName}
                  disabled={disabled}>
                  <CardIconWrapper>{icon}</CardIconWrapper>
                  <CardLabel>{label}</CardLabel>
                </CardFrame>
              );
            })}
          </Grid>
        );
      }}
    </Field>
  );
};

export default CardGroup;
